import WangEditor from 'wangeditor'
import { getToken } from '@utils/auth'

export default {
  name: 'wangEditor',
  props: {
    value: {
      type: String,
    },
    tag: {
      type: String,
      default: 'div',
    },
    menus: Array,
    /**
     [
     'head',  // 标题
     'bold',  // 粗体
     'italic',  // 斜体
     'underline',  // 下划线
     'strikeThrough',  // 删除线
     'foreColor',  // 文字颜色
     'backColor',  // 背景颜色
     'link',  // 插入链接
     'list',  // 列表
     'justify',  // 对齐方式
     'quote',  // 引用
     'emoticon',  // 表情
     'image',  // 插入图片
     'table',  // 表格
     'video',  // 插入视频
     'code',  // 插入代码
     'undo',  // 撤销
     'redo'  // 重复
     ]
     */
    colors: Array,
    /**
     [
     '#000000',
     '#eeece0',
     '#1c487f',
     '#4d80bf',
     '#c24f4a',
     '#8baa4a',
     '#7b5ba1',
     '#46acc8',
     '#f9963b',
     '#ffffff'
     ]
     */
    config: Object,
    zIndex: {
      type: Number,
      default: 1,
    },
  },
  data () {
    return {
      editor: null,
    }
  },
  watch: {
    value () {
      // 双向绑定，父组件同步到子组件
      if (this.value !== this.editor.txt.html()) {
        this.editor.txt.html(this.value)
      }
    },
  },
  mounted () {
    // 实例化编辑器
    // 双向绑定，子组件同步到父组件
    this.editor = new WangEditor(this.$el)

    this.editor.customConfig.uploadImgServer = this.uploadFilePath
    this.editor.customConfig.uploadFileName = this.uploadFileName
    this.editor.customConfig.uploadImgHeaders = {
      'SJ-Auth-Token': getToken(),
    }
    this.editor.customConfig.uploadImgParams = this.uploadFileParams

    this.editor.customConfig.uploadImgHooks = {
      before: function (xhr, editor, files) {

        // 图片上传之前触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，files 是选择的图片文件

        // 如果返回的结果是 {prevent: true, msg: 'xxxx'} 则表示用户放弃上传
        // return {
        //     prevent: true,
        //     msg: '放弃上传'
        // }
      },
      success: function (xhr, editor, result) {
        // 图片上传并返回结果，图片插入成功之后触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
      },
      fail: function (xhr, editor, result) {
        // 图片上传并返回结果，但图片插入错误时触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
      },
      error: function (xhr, editor) {
        // 图片上传出错时触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
      },
      timeout: function (xhr, editor) {
        // 图片上传超时时触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
      },

      // 如果服务器端返回的不是 {errno:0, data: [...]} 这种格式，可使用该配置
      // （但是，服务器端返回的必须是一个 JSON 格式字符串！！！否则会报错）
      customInsert: function (insertImg, result, editor) {
        // 图片上传并返回结果，自定义插入图片的事件（而不是编辑器自动插入图片！！！）
        // insertImg 是插入图片的函数，editor 是编辑器对象，result 是服务器端返回的结果

        // 举例：假如上传图片成功后，服务器端返回的是 {url:'....'} 这种格式，即可这样插入图片：
        var url = result.detail.url
        insertImg(url)
      },
    }

    this.editor.customConfig.onchange = (html) => {
      if (html !== this.value) {
        this.$emit('input', html)
      }
    }
    // 获得焦点事件
    this.editor.customConfig.onfocus = () => {
      this.$emit('focus')
    }
    // 失去焦点事件
    this.editor.customConfig.onblur = () => {
      this.$emit('blur')
    }
    // 配置数据
    this.editor.customConfig.zIndex = this.zIndex
    if (this.menus) this.editor.customConfig.menus = this.menus
    if (this.colors) this.editor.customConfig.colors = this.colors
    if (this.config) this.editor.customConfig = {...this.editor.customConfig, ...this.config}
    // 创建编辑器
    this.editor.create()
    // 赋初始值
    this.editor.txt.html(this.value)
  },
  destroyed () {
    // 销毁编辑器
    this.editor._offAllEvent()
  },
  render (h) {
    return h(this.tag, {
      class: {},
      style: {},
    }, this.$slots.default)
  },
}



// WEBPACK FOOTER //
// ./src/components/WangEditorV3Deprecated.js